// ParadiseJSY — Three.js scroll-driven scene for Shopify Dawn
// Reads asset URLs from window.__paradise injected by theme.liquid

(function () {
  const assets = window.__paradise || {};
  const canvas = document.getElementById('paradise-canvas');
  if (!canvas || typeof THREE === 'undefined') return;

  // Mobile : pas de système de survol/lentille — tout reste flou sauf l'élément en mouvement perpétuel
  const IS_MOBILE = window.matchMedia('(max-width: 749px)').matches;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
  camera.position.set(0, 0, 6);

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  if ('outputColorSpace' in renderer) renderer.outputColorSpace = THREE.SRGBColorSpace;
  else if ('outputEncoding' in renderer) renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.15;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setClearColor(0x000000, 0);

  const canvasFront = document.getElementById('paradise-canvas-front');
  const rendererFront = new THREE.WebGLRenderer({ canvas: canvasFront, antialias: true, alpha: true, powerPreference: 'high-performance' });
  rendererFront.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  if ('outputColorSpace' in rendererFront) rendererFront.outputColorSpace = THREE.SRGBColorSpace;
  else if ('outputEncoding' in rendererFront) rendererFront.outputEncoding = THREE.sRGBEncoding;
  rendererFront.toneMapping = THREE.ACESFilmicToneMapping;
  rendererFront.toneMappingExposure = 1.15;
  rendererFront.shadowMap.enabled = true;
  rendererFront.shadowMap.type = THREE.PCFSoftShadowMap;
  rendererFront.setClearColor(0x000000, 0);

  function enableAllLayers(light) { light.layers.enableAll(); }

  const hemi = new THREE.HemisphereLight(0xbfe8ff, 0x2a4d2a, 0.85);
  enableAllLayers(hemi); scene.add(hemi);

  const sun = new THREE.DirectionalLight(0xfff1c2, 2.8);
  sun.position.set(5, 8, 4);
  sun.castShadow = true;
  // Mobile : shadow map réduite (1024) pour alléger la mémoire GPU — 2048 sur desktop
  const SHADOW_SIZE = IS_MOBILE ? 1024 : 2048;
  sun.shadow.mapSize.set(SHADOW_SIZE, SHADOW_SIZE);
  sun.shadow.camera.near = 0.5; sun.shadow.camera.far = 30;
  sun.shadow.camera.left = -8; sun.shadow.camera.right = 8;
  sun.shadow.camera.top = 8; sun.shadow.camera.bottom = -8;
  sun.shadow.bias = -0.0008; sun.shadow.radius = 6;
  enableAllLayers(sun); sun.shadow.camera.layers.enableAll(); scene.add(sun);

  const rim = new THREE.DirectionalLight(0xffb090, 0.7);
  rim.position.set(-4, 2, -3); enableAllLayers(rim); scene.add(rim);

  const fill = new THREE.PointLight(0xffd56b, 1.3, 12);
  fill.position.set(0, -2, 2); enableAllLayers(fill); scene.add(fill);

  const accent = new THREE.PointLight(0x5BB5E8, 0.6, 8);
  accent.position.set(-2, 3, 2); enableAllLayers(accent); scene.add(accent);

  const treeFill = new THREE.DirectionalLight(0xfff5d8, 1.0);
  treeFill.position.set(-2, 4, 4); enableAllLayers(treeFill); scene.add(treeFill);

  let hero = null, girl = null, rock = null, chair = null, banana = null;
  const loader = new THREE.GLTFLoader();

  function center(obj, targetSize) {
    const box = new THREE.Box3().setFromObject(obj);
    const size = new THREE.Vector3(), cen = new THREE.Vector3();
    box.getSize(size); box.getCenter(cen);
    obj.position.sub(cen);
    const scl = targetSize / Math.max(size.x, size.y, size.z);
    obj.scale.setScalar(scl);
    const wrap = new THREE.Group(); wrap.add(obj); return wrap;
  }

  if (assets.bandanaUrl) {
    loader.load(assets.bandanaUrl, (gltf) => {
      hero = center(gltf.scene, 3.4);
      hero.traverse((c) => { if (c.isMesh && c.material) { c.material.envMapIntensity = 1.2; c.castShadow = true; c.receiveShadow = true; } });
      scene.add(hero);
    }, undefined, (e) => console.warn('paradise: bandana load error', e));
  }

  if (assets.girlUrl) {
    loader.load(assets.girlUrl, (gltf) => {
      girl = center(gltf.scene, 3.6);
      girl.position.set(8, 0, 0);
      girl.traverse((c) => { if (c.isMesh && c.material) { c.material.envMapIntensity = 1.2; c.castShadow = true; c.receiveShadow = true; } });
      scene.add(girl);
      window.__paradiseScene.girl = girl;
    }, undefined, (e) => console.warn('paradise: girl load error', e));
  }

  if (assets.rockUrl) {
    loader.load(assets.rockUrl, (gltf) => {
      rock = center(gltf.scene, 5.2);
      rock.position.set(0, -8, 0);
      rock.traverse((c) => { if (c.isMesh && c.material) { c.material.envMapIntensity = 1.0; c.castShadow = true; c.receiveShadow = true; } });
      scene.add(rock);
    }, undefined, (e) => console.warn('paradise: rock load error', e));
  }

  if (assets.chairUrl) {
    loader.load(assets.chairUrl, (gltf) => {
      chair = center(gltf.scene, 1.8);
      chair.position.set(-2.2, -0.5, 1.3);
      chair.traverse((c) => { if (c.isMesh && c.material) { c.material.envMapIntensity = 1.2; c.castShadow = true; c.receiveShadow = true; } });
      scene.add(chair);
    }, undefined, (e) => console.warn('paradise: chair load error', e));
  }

  if (assets.bananaUrl) {
    loader.load(assets.bananaUrl, (gltf) => {
      banana = center(gltf.scene, 4.0);
      banana.position.set(5.8, 1.5, -4.3);
      banana.traverse((c) => { if (c.isMesh && c.material) { c.material.envMapIntensity = 1.1; c.castShadow = true; c.receiveShadow = true; } });
      scene.add(banana);
    }, undefined, (e) => console.warn('paradise: banana load error', e));
  }

  const state = { scroll: 0, width: 1, height: 1, pointerX: 0, pointerY: 0 };
  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  // 5-act choreography
  const acts = [
    { rock: { pos: [-0.2,-0.8,-0.5], rot: [0,Math.PI+0.10,0], scale:1.20 }, hero: { pos:[0.0,0.4,0.9], rot:[0.04,0.08,0.05], scale:0.90 }, girl: { pos:[2.0,-0.2,1.1], rot:[0,-0.38,0], scale:1.00 }, chair: { pos:[-2.2,-0.5,1.3], rot:[0,0.295,0], scale:2.00 }, banana: { pos:[5.8,1.5,-4.3], rot:[0,-0.40,0], scale:2.12 }, camZ:12.0, camY:-0.6, lookY:0.2, exposure:1.10 },
    { rock: { pos: [-0.3,-0.9,-0.6], rot: [0,Math.PI+0.15,0], scale:1.15 }, hero: { pos:[-0.1,0.4,1.1], rot:[0.04,-0.10,0.03], scale:0.95 }, girl: { pos:[2.7,-0.1,1.3], rot:[0,-0.48,0], scale:1.05 }, chair: { pos:[-1.5,-0.4,1.5], rot:[0,0.195,0], scale:2.10 }, banana: { pos:[6.3,1.5,-4.3], rot:[0,-0.40,0], scale:2.07 }, camZ:8.6, camY:-0.8, lookY:0.5, exposure:1.18 },
    { rock: { pos: [-2.0,-1.1,-0.8], rot: [0,Math.PI+0.30,0], scale:1.00 }, hero: { pos:[-2.0,0.2,0.8], rot:[0.06,0.40,0.05], scale:0.90 }, girl: { pos:[0.2,-0.2,1.0], rot:[0,-0.07,0], scale:0.95 }, chair: { pos:[-3.7,-0.7,1.2], rot:[0,-0.205,0], scale:1.90 }, banana: { pos:[5.3,1.3,-3.8], rot:[0,-0.30,0], scale:1.85 }, camZ:9.4, camY:0.0, lookY:0.2, exposure:1.32 },
    { rock: { pos: [-1.6,-4.5,-1.6], rot: [0,Math.PI,0], scale:0.80 }, hero: { pos:[-2.4,0.8,-0.4], rot:[0.10,0.30,0.05], scale:0.65 }, girl: { pos:[2.7,0.4,-0.4], rot:[0,-0.48,0], scale:0.65 }, chair: { pos:[-1.5,0.2,0.1], rot:[0,0.195,0], scale:1.30 }, banana: { pos:[5.8,0.5,-4.3], rot:[0,-0.40,0], scale:1.46 }, camZ:10.0, camY:1.0, lookY:0.0, exposure:1.15 },
    { rock: { pos: [0.0,-0.8,-0.5], rot: [0,Math.PI-0.10,0], scale:1.25 }, hero: { pos:[0.2,0.5,1.0], rot:[0.04,0.20,0.08], scale:0.95 }, girl: { pos:[2.7,-0.1,1.4], rot:[0,-0.42,0], scale:1.05 }, chair: { pos:[-1.5,-0.4,1.6], rot:[0,0.295,0], scale:2.10 }, banana: { pos:[6.3,1.5,-4.3], rot:[0,-0.40,0], scale:2.16 }, camZ:8.2, camY:-1.2, lookY:0.6, exposure:1.22 },
  ];

  const wrap = document.getElementById('paradise-three-wrap');

  function applyAt(scroll) {
    const total = acts.length - 1;
    const f = clamp(scroll * total, 0, total);
    const i = Math.floor(f);
    const t = easeInOut(f - i);
    const a = acts[i], b = acts[Math.min(i + 1, total)] || a;

    function applyTo(obj, key) {
      if (!obj) return;
      const av = a[key], bv = b[key];
      obj.position.set(lerp(av.pos[0],bv.pos[0],t), lerp(av.pos[1],bv.pos[1],t), lerp(av.pos[2],bv.pos[2],t));
      obj.rotation.set(lerp(av.rot[0],bv.rot[0],t), lerp(av.rot[1],bv.rot[1],t), lerp(av.rot[2],bv.rot[2],t));
      obj.scale.setScalar(lerp(av.scale,bv.scale,t));
    }
    applyTo(rock,'rock'); applyTo(hero,'hero'); applyTo(girl,'girl'); applyTo(chair,'chair'); applyTo(banana,'banana');
    camera.position.set(0, lerp(a.camY??0, b.camY??0, t), lerp(a.camZ, b.camZ, t));
    camera.lookAt(0, lerp(a.lookY??0, b.lookY??0, t), 0);
    renderer.toneMappingExposure = lerp(a.exposure, b.exposure, t);
    rendererFront.toneMappingExposure = renderer.toneMappingExposure;

    const actIndex = Math.min(Math.round(f), total);
    if (wrap) wrap.dataset.paradiseAct = actIndex;
  }

  let elapsed = 0, heroSpin = 0;
  const clock = new THREE.Clock();

  function tick() {
    const dt = clock.getDelta();
    elapsed += dt;
    heroSpin += dt * 0.9;

    applyAt(state.scroll);

    // Pulsation lumières ambiantes
    accent.intensity = 0.6 + Math.sin(elapsed * 0.6) * 0.3;
    fill.intensity   = 1.3 + Math.sin(elapsed * 0.9 + 1.5) * 0.25;

    // Seul le bandana tourne sur lui-même en permanence
    if (hero) {
      hero.rotation.y += heroSpin;
    }

    check3DHover();
    renderer.render(scene, camera);

    // Mobile : pas de survol — seul l'élément en mouvement perpétuel (bandana) est rendu net en permanence
    const frontModel = IS_MOBILE ? hero : hoveredModel;

    if (frontModel) {
      const sp = window.__paradiseShadowPlane;
      const tr = window.__paradiseTree;
      const mb = window.__paradiseMailbox;
      const ph = window.__paradisePhoenix;
      if (sp) sp.visible = false;
      if (tr && tr !== frontModel) tr.visible = false;
      if (mb && mb !== frontModel) mb.visible = false;
      if (ph && ph !== frontModel) ph.visible = false;
      const others = [hero, girl, rock, chair, banana].filter(m => m && m !== frontModel);
      const wasVis = others.map(m => m.visible);
      others.forEach(m => { m.visible = false; });
      rendererFront.render(scene, camera);
      others.forEach((m, i) => { m.visible = wasVis[i]; });
      if (sp) sp.visible = true;
      if (tr && tr !== frontModel) tr.visible = true;
      if (mb && mb !== frontModel) mb.visible = true;
      if (ph && ph !== frontModel) ph.visible = true;
    } else {
      rendererFront.clear();
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  function resize() {
    const w = window.innerWidth, h = window.innerHeight;
    state.width = w; state.height = h;
    renderer.setSize(w, h, false);
    rendererFront.setSize(w, h, false);
    camera.aspect = w / h;
    camera.fov = 35 + (w / h < 1 ? (h / w) * 0.9 * 18 : 0);
    camera.updateProjectionMatrix();
  }
  resize();
  window.addEventListener('resize', resize);

  window.addEventListener('scroll', () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    state.scroll = max > 0 ? clamp(window.scrollY / max, 0, 1) : 0;
  }, { passive: true });

  const wrapEl = document.getElementById('paradise-three-wrap');
  const raycaster = new THREE.Raycaster();
  const pointerNDC = new THREE.Vector2();
  let lensTimeout = null, hoverOffTimeout = null, hoveredModel = null, pointerInitialized = false;

  function setHovered(model) {
    if (hoveredModel === model) return;
    hoveredModel = model;
    document.body.classList.toggle('paradise-hover-3d', !!model);
  }

  function check3DHover() {
    if (IS_MOBILE || !pointerInitialized) return;
    const targets = [hero, girl, chair, banana, window.__paradiseTree, window.__paradiseMailbox, window.__paradisePhoenix].filter(Boolean);
    if (!targets.length) return;
    raycaster.setFromCamera(pointerNDC, camera);
    const hits = raycaster.intersectObjects(targets, true);
    if (hits.length > 0) {
      let obj = hits[0].object;
      while (obj && obj.parent && !targets.includes(obj)) obj = obj.parent;
      if (targets.includes(obj)) {
        if (hoverOffTimeout) { clearTimeout(hoverOffTimeout); hoverOffTimeout = null; }
        setHovered(obj);
      }
    } else if (!hoverOffTimeout && hoveredModel) {
      hoverOffTimeout = setTimeout(() => { setHovered(null); hoverOffTimeout = null; }, 120);
    }
  }

  // Survol / lentille : desktop uniquement — sur mobile le fond et les éléments restent flous
  if (!IS_MOBILE) {
    window.addEventListener('pointermove', (e) => {
      state.pointerX = (e.clientX / state.width) * 2 - 1;
      state.pointerY = (e.clientY / state.height) * 2 - 1;
      pointerNDC.x = state.pointerX; pointerNDC.y = -state.pointerY;
      pointerInitialized = true;

      if (wrapEl) {
        const px = state.pointerX * -22, py = state.pointerY * -12;
        wrapEl.style.setProperty('--bg-px', px.toFixed(1) + 'px');
        wrapEl.style.setProperty('--bg-py', py.toFixed(1) + 'px');
        wrapEl.style.setProperty('--mx', (e.clientX - px) + 'px');
        wrapEl.style.setProperty('--my', (e.clientY - py) + 'px');
      }
      document.body.classList.add('paradise-lens-active');
      if (lensTimeout) clearTimeout(lensTimeout);
      lensTimeout = setTimeout(() => document.body.classList.remove('paradise-lens-active'), 1800);
      check3DHover();
    }, { passive: true });

    window.addEventListener('touchstart', (e) => {
      const t = e.touches[0]; if (!t || !wrapEl) return;
      wrapEl.style.setProperty('--mx', t.clientX + 'px');
      wrapEl.style.setProperty('--my', t.clientY + 'px');
      document.body.classList.add('paradise-lens-active');
      if (lensTimeout) clearTimeout(lensTimeout);
      lensTimeout = setTimeout(() => document.body.classList.remove('paradise-lens-active'), 1800);
      pointerNDC.x = (t.clientX / state.width) * 2 - 1;
      pointerNDC.y = -((t.clientY / state.height) * 2 - 1);
      pointerInitialized = true; check3DHover();
    }, { passive: true });

    window.addEventListener('touchmove', (e) => {
      const t = e.touches[0]; if (!t || !wrapEl) return;
      wrapEl.style.setProperty('--mx', t.clientX + 'px');
      wrapEl.style.setProperty('--my', t.clientY + 'px');
      pointerNDC.x = (t.clientX / state.width) * 2 - 1;
      pointerNDC.y = -((t.clientY / state.height) * 2 - 1);
      pointerInitialized = true; check3DHover();
    }, { passive: true });
  }

  window.__paradiseScene = { renderer, scene, camera, hero, girl, state, acts };
})();
